/**
 * Convert ISO 2-letter country code to emoji flag
 * @param {string} countryCode - Two letter country code (e.g., 'US', 'GB', 'DE')
 * @returns {string} - Emoji flag or fallback character
 */
export function getFlagEmoji(countryCode) {
  if (!countryCode || countryCode.length !== 2) {
    return '🌍'; // World globe as fallback
  }

  try {
    const codePoints = countryCode
      .toUpperCase()
      .split('')
      .map(char => 127397 + char.charCodeAt());
    return String.fromCodePoint(...codePoints);
  } catch {
    console.warn('Failed to generate flag for country code:', countryCode);
    return '🌍'; // Fallback to world globe
  }
}

// Alias for backward compatibility
export const getCountryFlag = getFlagEmoji;

/**
 * Get flag with country name for display
 * @param {string} countryName - Full country name
 * @param {string} countryCode - Two letter country code
 * @returns {string} - Flag emoji + country name
 */
export function getFlagWithCountryName(countryName, countryCode) {
  const flag = getFlagEmoji(countryCode);
  return `${flag} ${countryName}`;
}

